/**
 * Jump to a Help section from anywhere in the app. App.tsx listens for the
 * event and switches to the Help tab; HelpTab reads the section from the URL.
 */
export type HelpSection =
  | 'user-guide'
  | 'choosing-a-method'
  | 'nec-220-87'
  | 'ami-data'
  | 'direct-measurement';

export function navigateToHelp(section: HelpSection): void {
  window.history.pushState({}, '', `?section=${section}`);
  window.dispatchEvent(new CustomEvent('trueload:navigate-help', { detail: section }));
}
